import { z } from "zod";

import { hasUniqueValues, IsoTimestampSchema, UserTextSchema, UUIDSchema } from "./shared";

export const ReflectionTypeSchema = z.enum([
  "reflection",
  "gratitude",
  "circumstance_change",
]);

const ReflectionMutableShape = {
  duaId: UUIDSchema,
  body: UserTextSchema.trim().min(1),
  type: ReflectionTypeSchema.default("reflection"),
  personIds: z.array(UUIDSchema).max(100).refine(hasUniqueValues).default([]),
  occurredAt: IsoTimestampSchema.optional(),
} satisfies z.ZodRawShape;

export const ReflectionCreateSchema = z.object(ReflectionMutableShape).strict();

export const ReflectionSchema = z
  .object({
    id: UUIDSchema,
    ...ReflectionMutableShape,
    createdAt: IsoTimestampSchema,
    updatedAt: IsoTimestampSchema,
    deletedAt: IsoTimestampSchema.optional(),
  })
  .strict();

export const ReflectionUpdateSchema = z
  .object({
    body: UserTextSchema.trim().min(1).optional(),
    type: ReflectionTypeSchema.optional(),
    personIds: z.array(UUIDSchema).max(100).refine(hasUniqueValues).optional(),
    occurredAt: IsoTimestampSchema.optional(),
  })
  .strict();

export type ReflectionType = z.infer<typeof ReflectionTypeSchema>;
export type DuaReflection = z.output<typeof ReflectionSchema>;
export type Reflection = DuaReflection;
export type CreateReflectionInput = z.input<typeof ReflectionCreateSchema>;
export type UpdateReflectionInput = z.input<typeof ReflectionUpdateSchema>;
